import axios from 'axios'

const instance = axios.create({
  baseURL: window.env && window.env.baseHost
})

export default instance
